import { gql } from '@apollo/client'

export const ROLES_ATTRIBUTES = gql`
  fragment rolesAttributes on Role {
    id
    createdAt
    updatedAt
    builderId
    auth0Identifier
    name
    description
    permissions {
      id
      action
      resource
    }
    countOfUsers
  }
`

export const GET_PERMISSIONS_BY_ROLE = gql`
  query permissionsByRole_UI($roleId: String!) {
    permissionsByRole(roleId: $roleId) {
      id
      action
      resource
    }
  }
`

export const CREATE_ROLE = gql`
  mutation createRole_UI($input: CreateRoleInput!) {
    createRole(input: $input) {
      ...rolesAttributes
    }
  }
  ${ROLES_ATTRIBUTES}
`

export const UPDATE_ROLE_PERMISSIONS = gql`
  mutation updateRolePermissions_UI(
    $id: String!
    $input: UpdateRolePermissionsInput!
  ) {
    updateRolePermissions(id: $id, input: $input) {
      ...rolesAttributes
    }
  }
  ${ROLES_ATTRIBUTES}
`
